import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from '../../../services/auth.service';
import * as LoginActions from './actions';
import { EMPTY, catchError, exhaustMap, map, mergeMap, of, tap } from 'rxjs';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class LoginEffects {
  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoginActions.login),
      exhaustMap((action) =>
        this.authService.login(action.user, action.password).pipe(
          map((response) => LoginActions.loginSuccess(response)),
          catchError((error: HttpErrorResponse) =>
            of(LoginActions.loginError({ error: error }))
          )
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginActions.loginSuccess),
        tap((action) => {
          this.router.navigate(['/home']);
        })
      ),
    { dispatch: false }
  );

  loginError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginActions.loginError),
        tap((action) => {
          if (action.error.status == 401) {
            this.snackbar.open('Credenciales inválidas');
            return;
          }

          this.snackbar.open('Ocurrió un error al procesar la solicitud');
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private snackbar: MatSnackBar
  ) {}
}
